<template>
    <van-popup v-if="projectBaseDetailPopupShow " :value="projectBaseDetailPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="project_base_detail_wrap" v-loading="loading">
            <div class="project_base_detail_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
            </div>
            <div class="project_base_detail_bottom">
                <div class="project_detail_base_box">
                    <div class="top">
                        <h5 class="" v-text="projectDetail.project_manage_name"></h5>
                        <span class="status_wrap">
                        <span class="status_text status0" v-if="projectDetail.status == 0 ">进行中</span>
                        <span class="status_text status1" v-if="projectDetail.status == 1 ">已完结</span>
                        <span class="status_text status2" v-if="projectDetail.status == 2" >已关闭</span>
                    </span>
                    </div>
                    <div class="bottom">
                        <div class="field_item">
                            <div class="field_name">项目负责人</div>
                            <div class="field_value">
                                 <span class="user_head" v-if="projectDetail.head_user" @click="userDetailPopupShow = true">
                          <img :src="projectDetail.head_user.avatar ? projectDetail.head_user.avatar : defaultImg" alt="">
                          <span class="ellipsis" v-text="projectDetail.head_user.name"></span>
                     </span>
                            </div>
                        </div>
                        <div class="field_item">
                            <div class="field_name">项目负责人</div>
                            <div class="field_value" v-text="projectDetail.country_region + ' ' + projectDetail.addr"> </div>
                        </div>
                        <div class="field_item">
                            <div class="field_name">项目概况</div>
                            <div class="field_value" v-text="projectDetail.note"> </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <userDetailDialog  v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow"  :userId="projectDetail.head_user.id" />

    </van-popup>
</template>
<script>
import {} from "@/api/index.js"
import userDetailDialog from "@/components/mComponents/userDetailDialog";
export default {
    name: "project_base_detail",
    components: {
        userDetailDialog
    },
    props: {
        projectBaseDetailPopupShow: {
            type: Boolean,
            default: false
        },
        projectDetail: {
            type: Object,
            default: ()=>{}
        },

    },
    data() {
        return {
            loading:false,
            userDetailPopupShow:false,
        }
    },
    created() {

    },
    methods: {

        handleClickClose() {
            this.$emit("update:projectBaseDetailPopupShow", false)
        },

    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>
